import { IContactState } from "@shared/interfaces"
import { createSelector } from "reselect"

const selectContact = (state: any) => state.contact

export const selectContactState = createSelector(
	[selectContact],
	(state: IContactState) => ({ ...state })
)
